const apiPrefix = '/api/';

export const get = async (uri: string): Promise<any> => {
    const response = await fetch(`${apiPrefix}${uri}`)
        .then((response) => response.json())
        .catch((error) => console.error(error));

    return response;
};
